export default __webpack_public_path__ + "tmp_src/components/StockStatus/StockStatus.css.liquid";